import MainNavigationLegacy from './MainNavigationLegacy'

export default MainNavigationLegacy
